import React from "react"

const entryKey = (menuGroup, name) => `${menuGroup ?? ""}|${name}`

// Merges the static frontend menu with the menus the backend grants
// (GET /api/authWeb/user/v1/userAppMenus).
// A frontend entry is shown only if the backend grants the same name and group.
// Backend-only menus are appended after the frontend entries.
// Each menu appears once per group, even if the static list or the backend
// response repeats it. If the static list repeats a name within a group,
// the first entry wins.
export function mergeMenuEntries(frontendMenus, backendMenus) {
  const result = []
  const seen = new Set()

  // First pass: frontend items that have backend permission, in frontend order
  frontendMenus.forEach((frontendItem, index) => {
    const key = entryKey(frontendItem.menuGroup, frontendItem.name)
    if (seen.has(key)) return
    const backendItem = backendMenus.find(
      item => item.menu === frontendItem.name && item.menuGroup === frontendItem.menuGroup
    )
    if (backendItem) {
      seen.add(key)
      result.push({
        ...frontendItem,
        // Backend menuGroup overrides frontend menuGroup, but preserve frontend if backend is null
        menuGroup: backendItem.menuGroup !== null ? backendItem.menuGroup : frontendItem.menuGroup,
        menuID: backendItem.menuID,
        originalIndex: index, // Preserve original frontend order
      })
    }
  })

  // Second pass: backend-only items (not defined in frontend)
  backendMenus.forEach((backendItem, index) => {
    const existsInFrontend = frontendMenus.some(item => item.name === backendItem.menu)
    const key = entryKey(backendItem.menuGroup, backendItem.menu)
    if (!existsInFrontend && !seen.has(key)) {
      seen.add(key)
      result.push({
        name: backendItem.menu,
        href: "#",
        contextUri: "",
        actionType: "",
        icon: <i className="bx bx-circle"></i>,
        menuGroup: backendItem.menuGroup,
        menuID: backendItem.menuID,
        originalIndex: frontendMenus.length + index, // Place after frontend items
      })
    }
  })

  return result
}
